import React from "react";
import CardSimple from "../../../../../components/basic/CardSimple";

const UserTrouble = () => {
  return (
    <div id="trouble-login">
      <br />
      <div>
        <CardSimple>
          <div className="support-wrapper support-manual">
            <h2>Login Issues</h2>
            <h3 style={{ color: "#000" }}>Inactive Employee</h3>
            <p>
              An inactive employee can’t log in. If this is a system error, edit
              the employee and change the status to active. If this is not a
              system error, please contact your management team.
            </p>
            <h3 style={{ color: "#000" }}>Restoring a Password</h3>
            <h4>From Store Owner/Manager Side</h4>
            <ul>
              <li>Go to Menu > Users > Employee</li>
              <li>
                In the Employee Table, search for the employee who needs the
                password to be reset
              </li>
              <li>Click on the Edit Icon</li>
              <li>In the pop up menu click on Reset Password</li>
              <li>
                The employee should receive an email with a randomly-generated
                Password
              </li>
              <li>The employee can now log in now with the new password</li>
            </ul>
            <h4>Resetting a Password at log in time</h4>
            <ul>
              <li>Go to the Login Page of TechPOS</li>
              <li>Click on Forget Password</li>
              <li>
                Enter the username. If it is in the database, the employee
                should receive an email containing a new password
              </li>
            </ul>
            <h3 style={{ color: "#000" }}>
              Change a Password When the Employee has access to his/her account
            </h3>
            <ul>
              <li>
                The Employee has to login with his/her current credentials
              </li>
              <li>
                Right next to the employee’s name, click on the 3 vertical dots
              </li>
              <li>Click on Change Password</li>
              <li>
                Enter the old password and then the new one. Click on Save
              </li>
            </ul>
          </div>
        </CardSimple>
      </div>
      <div id="trouble-forgot-pw">
        <br />
        <CardSimple>
          <div className="support-wrapper support-manual">
            <h2>Employee - Forgot password</h2>
            <ul>
              <li>Go to Menu > Users > Employee</li>
              <li>
                In the employee table, look for the employee you want to store
                the password for
              </li>
              <li>Click on the Edit Icon</li>
              <li>Click on Reset Password from the Pop up Menu</li>
              <li>
                The employee should get an email with a randomly-generated
                password
              </li>
              <li>The employee should now log in with that password</li>
              <p>
                <strong>NOTE:</strong> To change the Password, the employee
                should follow the steps in the section 'Employee - Change
                password'
              </p>
              <h3>Restoring Password at Login Time</h3>
              <ul>
                <li>Go to the log in page of TechPOS</li>
                <li>Click on Forgot Password</li>
                <li>
                  Enter your email. If it is in the database, you will get an
                  email with a randomly-generated password. Please log in with
                  that password.
                </li>
              </ul>
            </ul>
          </div>
        </CardSimple>
      </div>
      <div id="trouble-change-pw">
        <br />
        <CardSimple>
          <div className="support-wrapper support-manual">
            <h2>Employee - Change password</h2>
            <ul>
              <li>Login with your current credentials.</li>
              <li>Click on Change Password</li>
              <li>
                Enter the old password, and then the new one. Click on Save
              </li>
              <p>
                <b>
                  <strong>NOTE:</strong> The password should be at least 8
                  characters and must contain at least 1 uppercase letter, 1
                  lowercase letter, a symbol and number.
                </b>
              </p>
            </ul>
          </div>
        </CardSimple>
      </div>
    </div>
  );
};

export default UserTrouble;
